import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import { useHistory, useParams } from "react-router-dom";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { useState } from "react";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import ResultHandler from "../../../components/ResultHandler";
import { getEmployee } from "../../../api/employees";
import PayslipesTable from "../payslipes/PayslipesTable";
import RelatedPriceComponentsTable from "../price-components/RelatedPriceComponentsTable";
import FIELDS, { INFO_FIELDS } from "./CONSTANT";
import moment from "moment";
import ExperienceTable from "./ExperienceTable";
import EducationTable from "./EducationTable";
import InsuranceTable from "../insurance/InsuranceTable";
import { languageTempletsOptions } from "../../../utils/langTemplets";
import HolidaysTable from "../holidays/LeavesTable";
import EmpReservationsTable from "./EmpReservationsTable";

export default function EmployeeProfile({}) {
  const navigate = useHistory();
  const params = useParams();
  const [employee, setEmployee] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getEmployee,
    params.id,
    (response) => {
      setEmployee({
        ...response.data.data.employee,
      });
    }
  );

  const [infoOpen, setInfoOpen] = useState("open");
  const [priceComponentsOpen, setPriceComponentsOpen] = useState("open");
  const [payslipesOpen, setPayslipesOpen] = useState("open");

  const [refNumOpen, setRefNumOpen] = useState("open");
  const [empInfoOpen, setEmpInfoOpen] = useState("open");

  const [experienceOpen, setExperienceOpen] = useState("open");
  const [educationOpen, setEducationOpen] = useState("open");
  const [insuranceOpen, setInsuranceOpen] = useState("open");
  const [holidaysOpen, setHolidaysOpen] = useState("open");
  const [reservationsOpen, setReservationsOpen] = useState("open");

  // console.log(employee);

  return (
    <div className="page-content company-profile-page">
      <div className="container-fluid">
        <Breadcrumb title="" breadcrumbItem={"Employee Profile"} />
        <ResultHandler loading={instenceLoading} />
        <Container fluid>
          {employee && (
            <>
              <Row>
                <Col
                  md={employee.id_front_side ? 6 : 12}
                  lg={employee.id_front_side ? 8 : 12}
                >
                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={empInfoOpen}
                    toggle={() => setEmpInfoOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        <h5 className="mb-0 text-uppercase">{employee.name}</h5>
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        {INFO_FIELDS.map((f) => (
                          <Row className="mb-1" key={f.key}>
                            <Col xs={6}>
                              <Label className="mb-0">{f.label}</Label>
                            </Col>
                            <Col xs={6}>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  textTransform: "capitalize",
                                }}
                              >
                                {f.type == "date"
                                  ? moment(employee[f.key]).format(
                                      "DD MMM YYYY"
                                    )
                                  : f.type == "lang"
                                  ? languageTempletsOptions.find(
                                      (lang) => lang.value == employee[f.key]
                                    )?.label
                                  : employee[f.key]}
                              </span>
                            </Col>
                          </Row>
                        ))}
                        <div
                          className="d-flex"
                          style={{
                            justifyContent: "flex-end",
                            marginTop: "20px",
                          }}
                        >
                          <Button
                            color="dark"
                            onClick={() =>
                              navigate.push("/edit-employee/" + employee.id)
                            }
                          >
                            Edit
                          </Button>
                        </div>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Col>

                {employee.id_front_side && (
                  <Col md={6} lg={4}>
                    <Accordion
                      style={{ marginBottom: "20px" }}
                      open={refNumOpen}
                      toggle={() => setRefNumOpen((i) => (i ? null : "open"))}
                    >
                      <AccordionItem>
                        <AccordionHeader targetId="open">
                          Request Reference Number
                        </AccordionHeader>
                        <AccordionBody
                          style={{ backgroundColor: "white" }}
                          accordionId="open"
                        >
                          <img
                            src={employee.id_front_side}
                            style={{ width: "100%", borderRadius: "6px" }}
                            className="mb-3"
                          />
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  </Col>
                )}
              </Row>

              <Row>
                <Col lg={8}>
                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={payslipesOpen}
                    toggle={() => setPayslipesOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Payslipes
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <PayslipesTable
                          hasBlockPaymentBtn
                          blockPayments={employee.blockPayments}
                        />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={priceComponentsOpen}
                    toggle={() =>
                      setPriceComponentsOpen((i) => (i ? null : "open"))
                    }
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Price Components
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <RelatedPriceComponentsTable
                          relatedId={employee.id}
                          type={"employees"}
                        />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={insuranceOpen}
                    toggle={() => setInsuranceOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Insurance
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <InsuranceTable />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={experienceOpen}
                    toggle={() => setExperienceOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Experience
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <ExperienceTable employeeId={employee.id} />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={educationOpen}
                    toggle={() => setEducationOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Education
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <EducationTable employeeId={employee.id} />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={holidaysOpen}
                    toggle={() => setHolidaysOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Holidays
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <HolidaysTable />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>

                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={reservationsOpen}
                    toggle={() =>
                      setReservationsOpen((i) => (i ? null : "open"))
                    }
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Reservations
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <EmpReservationsTable
                          reservations={employee.reservations}
                        />
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Col>

                <Col lg={4}>
                  <Accordion
                    style={{ marginBottom: "20px" }}
                    open={infoOpen}
                    toggle={() => setInfoOpen((i) => (i ? null : "open"))}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="open">
                        Personal Information
                      </AccordionHeader>
                      <AccordionBody
                        style={{ backgroundColor: "white" }}
                        accordionId="open"
                      >
                        <Row>
                          {FIELDS.filter((f) => f.type != "file").map((f) => (
                            <Col md={6} className="mb-2" key={f.key}>
                              <Label className="mb-0">{f.label}</Label>
                              <div style={{ fontWeight: "bold" }}>
                                {f.type == "date"
                                  ? moment(employee[f.key]).format(
                                      "DD MMM YYYY"
                                    )
                                  : f.type == "fixed-select" &&
                                    employee[f.key] == true
                                  ? "Yes"
                                  : f.type == "fixed-select" &&
                                    employee[f.key] == false
                                  ? "No"
                                  : employee[f.key]}
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </div>
  );
}
